import './style.css'
import { React, useState, useEffect } from 'react'
import TiposDocumento from "../integracao/TiposDocumento";
import Documentos from "../integracao/Documentos";
import Integracoes from "../integracao/Integracoes";
import Requisitos from "../integracao/Requisitos";
import Dashboard from "../Dashboard"

const Index = (props) => {
    useEffect(() => {
        // console.log("Acessou componente Navbar.js");
        if (!props.activeScreen)
            _dashBoard()
    }, [props.activeScreen]);

    function _tipoDocumento() {
        if (props.setActiveScreen)
            props.setActiveScreen(<TiposDocumento onCloseEv={() => props.setActiveScreen(null)} />)
    }

    function _requisitos() {
        if (props.setActiveScreen)
            props.setActiveScreen(<Requisitos onCloseEv={() => props.setActiveScreen(null)} />)
    }

    function _integracoes() {
        if (props.setActiveScreen)
            props.setActiveScreen(<Integracoes onCloseEv={() => props.setActiveScreen(null)} />)
    }

    function _docEmpresa() {
        if (props.setActiveScreen)
            props.setActiveScreen(<Documentos onCloseEv={() => props.setActiveScreen(null)} empresa={true} />)
    }

    function _docFuncionarios() {
        if (props.setActiveScreen)
            props.setActiveScreen(<Documentos
                onCloseEv={() => props.setActiveScreen(null)}
                funcionarios={true}
            />)
    }

    function _dashBoard() {
        if (props.setActiveScreen)
            props.setActiveScreen(<Dashboard />)
    }


    return (
        <nav className='navbar navbar-expand-lg navbar-light bg-light mb-2 rounded'>
            <div className='container-fluid'>
                {/* <a href="#" className='navbar-brand' >Integração</a> */}
                <button
                    className='navbar-toggler'
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle Navigation"
                >
                    <span className='navbar-toggler-icon' style={{ fontSize: "15px" }}></span>
                </button>
                <div className='collapse navbar-collapse' id='navbarNav'>
                    <ul className='navbar-nav ' style={{ fontSize: "25px" }}>
                        <li className='nav-item ml-15 align-all'>
                            <a href="#" className='nav-link' aria-current="page" onClick={_dashBoard} title="Dashboard - Página Inicial"><i className="fa fa-home"></i></a>
                        </li>
                        <li className='nav-item ml-15 align-all'>
                            <a href="#" className='nav-link' aria-current="page" onClick={_integracoes} title="Integrações"><i className="fa fa-indent fa-fw f-left"></i></a>
                        </li>
                        <li className='nav-item ml-15 align-all'>
                            <a href="#" className='nav-link' aria-current="page" onClick={_docEmpresa} title="Documentos da Empresa"><i className="fa fa-building"></i></a>
                        </li>
                        <li className='nav-item ml-15 align-all'>
                            <a href="#" className='nav-link' aria-current="page" onClick={_docFuncionarios} title="Documentos dos Técnicos"><i className="fa fa-user"></i></a>
                        </li>
                        <li className='nav-item ml-15 align-all'>
                            <a href="#" className='nav-link' aria-current="page" onClick={_requisitos} title="Requisitos de Integração"><i className="fa fa-cube fa-fw f-left"></i></a>
                        </li>
                        <li className='nav-item ml-15 align-all'>
                            <a href="#" className='nav-link' aria-current="page" onClick={_tipoDocumento} title="Tipos de Documento"><i className="fa fa-filter fa-fw f-left"></i></a>
                        </li>
                    </ul>
                </div>
            </div>

        </nav>
    )

}

export default Index;